import { cloneDeep } from 'lodash';
import { STATE_ADDED, STATE_SET, STATE_DELETED, STATE_EDITED } from 'src/app/redux/redux-types';
import { reduxStateTypes } from 'src/types';

export const stateDefaultState: reduxStateTypes.StateType = {
  stateNodeList: [],
};

export const stateReducer = (
  state = stateDefaultState,
  action: reduxStateTypes.ActionType,
): reduxStateTypes.StateType => {
  switch (action.type) {
    case STATE_SET:
      return {
        ...state,
        stateNodeList: action.payload,
      };
    case STATE_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.stateNodeList.some((item) => item.id === action.payload.id);

      if (exists) {
        return state;
      }
      return {
        ...state,
        stateNodeList: [...state.stateNodeList, action.payload],
      };
    case STATE_EDITED:
      const updateIndex = state.stateNodeList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        stateNodeList: [
          ...state.stateNodeList.slice(0, updateIndex),
          action.payload,
          ...state.stateNodeList.slice(updateIndex + 1),
        ],
      };
    case STATE_DELETED:
      return {
        ...state,
        stateNodeList: state.stateNodeList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
